<template>
<div>
    <el-container>
    <el-aside width="400px">
        <el-menu @select="handleMenuSelect" default-active="1" style="background-color: rgb(170, 197, 219);position: fixed;top: 30%;transform: translateY(-50%);">
            <el-menu-item index="1" style="font-weight: bold;font-size: medium;">Sample Information</el-menu-item>
            <el-menu-item index="2" style="font-weight: bold;font-size: medium;">Enhancer List</el-menu-item>
            <el-menu-item index="3" style="font-weight: bold;font-size: medium;">Comparison of SEs and TEs</el-menu-item>
            <el-menu-item index="4" style="font-weight: bold;font-size: medium;">Genomic Features of TEs</el-menu-item>
        </el-menu>
    </el-aside>
        <el-main>
        <el-col :span="12">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 80px;font-size: 25px;">
            <el-breadcrumb-item :to="{ path: '/single' }">
                <i class="el-icon-location" style="margin-right:5px;color: #1B89C4;font-weight: bold;"></i>Search
            </el-breadcrumb-item>
            <el-breadcrumb-item>Typical Enhancers</el-breadcrumb-item>
            </el-breadcrumb>
        </el-col>
        <el-col :span="12" id="info">
            <el-card>
                <template v-slot:header>
                <div class="clearfix">
                    <span style="font-weight: bold;"><i class="el-icon-s-data" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Sample information</span>
                </div>
                </template>
            <div>
                <Ensample :species="this.$route.params.Species" :tissue="this.$route.params.Tissue" />
            </div>
            </el-card>
        </el-col>
        <el-col :span="24" id="enlist">
                <Enlist :species="this.$route.params.Species" :tissue="this.$route.params.Tissue" />
        </el-col>
        <el-col :span="24" id="comparison">
            <div>
                <h1 style="text-align: center;margin-top: 15px;margin-bottom: 5px;background-color: #1B89C4;color: azure;font-size: 35px;">
                    <i class="el-icon-s-claim" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Comparision of Super enhancers and Non-super enhancers</h1>
            </div>
        </el-col>
        <el-col :span="12">
            <el-card>
                <template v-slot:header>
                <div class="clearfix">
                    <span style="font-weight: bold;"><i class="el-icon-pie-chart" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Proportion of Super enhancers and Non-super enhancers</span>
                </div>
                </template>
            <div>
                <Issuper :species="this.$route.params.Species" :tissue="this.$route.params.Tissue" />
            </div>
            </el-card>
        </el-col>
        <el-col :span="12">
            <el-card>
                <template v-slot:header>
                <div class="clearfix">
                    <span style="font-weight: bold;"><i class="el-icon-s-data" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Length of Super enhancers and Non-super enhancers</span>
                </div>
                </template>
            <div>
                <Vslength :species="this.$route.params.Species" :tissue="this.$route.params.Tissue" />
            </div>
            </el-card>
        </el-col>
        <el-col :span="24">
            <Sevste :species="this.$route.params.Species" :tissue="this.$route.params.Tissue" />
          </el-col>
        <el-col :span="24" id="features">
            <div>
                <h1 style="text-align: center;margin-top: 15px;margin-bottom: 5px;background-color: #1B89C4;color: azure;font-size: 35px;">
                    <i class="el-icon-s-claim" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Genomic Features of Typical enhancers</h1>
            </div>
        </el-col>
        <el-col :span="12">
            <Teanno :species="this.$route.params.Species" :tissue="this.$route.params.Tissue" />
        </el-col>
        <el-col :span="12">
            <Techr :species="this.$route.params.Species" :tissue="this.$route.params.Tissue" />
        </el-col>
        </el-main>
</el-container>
</div>
</template>

<script>
import Ensample from './Ensample.vue';
import Enlist from './Enlist.vue';
import Issuper from './Issuper.vue';
import Vslength from './Vslength.vue';
import Sevste from './Sevste.vue';
import Teanno from './Teanno.vue';
import Techr from './Techr.vue';

export default {
    name: "Enpanel",
    components:{
        Ensample,
        Enlist,
        Issuper,
        Vslength,
        Sevste,
        Teanno,
        Techr,
    },
    data(){
        return{
        }
    },
    props: {
        species: String,
        tissue: String,
    },
    methods: {
    handleMenuSelect(index) {
      switch (index) {
        case "1":
          this.scrollToInformation();
          break;
        case "2":
          this.scrollToList();
          break;
        case "3":
          this.scrollToComparison();
          break;
        case "4":
          this.scrollToFeatures();
          break;
        default:
          break;
      }
    },
    scrollToInformation() {
    // 使用原生 JavaScript 实现滚动效果到相应位置
      const elInfo = document.getElementById("info");
      if (elInfo) {
        elInfo.scrollIntoView({ behavior: "smooth" });
      }
    },
    scrollToList() {
    // 使用原生 JavaScript 实现滚动效果到相应位置
      const elList = document.getElementById("enlist");
      if (elList) {
        elList.scrollIntoView({ behavior: "smooth" });
      }
    },
    scrollToComparison() {
      const elComparison = document.getElementById("comparison");
      if (elComparison) {
        elComparison.scrollIntoView({ behavior: "smooth" });
      }
    },
    scrollToFeatures() {
      const elFeatures = document.getElementById("features");
      if (elFeatures) {
        elFeatures.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
}
</script>

<style>
.el-card {
margin-top: 20px;
}
.clearfix{
font-size: larger;
}
</style>


// WEBPACK FOOTER //
// src/components/teAnalysis/Enpanel.vue